import { catchError } from 'rxjs/operators';
import { BaseService } from './../../../shared/service/base.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
// import {ItemAttach} from 'src/app/shared/modal/inventory/item/itemAttach';
import { Item } from 'src/app/shared/modal/inventory/item/item';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  accountManagerEndPoint = 'api/v1/account-manager';
  serviceCategoryEndPoint = 'api/v1/service-category';
  employeeTypeEndPoint = 'api/v1/employee-type';
  shiftsEndPoint = 'api/v1/shift';
  usersEndPoint = 'api/v1/appuser';
  customerEndPoint = 'api/v1/customer';
  customerBranchEndPoint = 'api/v1/customer-branch';
  branchEmployeeEndPoint = 'api/v1/branch-employee';
  customerEmployeeEndPoint = 'api/v1/customer';
  countriesEndPoint = 'api/v1/country';
  governoratesEndPoint = 'api/v1/governorate';
  citiesEndPoint = 'api/v1/city';
  deliveryMethodList = 'api/v1/delivery-method';
  serviceShopping = 'api/v1/service/shopping';
  serviceCategory = 'api/v1/service-category/services';
  bankList = 'api/v1/bank';
  attachesBranch = 'api/v1/branch-attach/findByBranchId';
  supplierEmployeeEndPoint = 'api/v1/supplier/customer';
  branchBasicInfoEndPoint = 'api/v1/customer-branch/basic';
  branchDetailsEndPoint = 'api/v1/customer-branch/detail';
  branchGeneralEndPoint = 'api/v1/customer-branch/general';
  configurationEndPoint = 'api/v1/customer-branch/e-invoice/configuration';
  branchBusinessEndPoint = 'api/v1/customer-branch/business';
  branchAddressEndPoint = 'api/v1/customer-branch/address';
  branchDeliveryMethodsEndPoint = 'api/v1/customer-branch/delivery';
  branchTimeSheetEndPoint = 'api/v1/customer-branch/timeSheet';
  branchDayofWorkEndPoint = 'api/v1/customer-branch/dayofwork';
  salaryElementEarning = 'api/v1/salary-element/earning';
  invoiceIssuingType = 'api/v1/invoice-issuing-type';
  customers = new BehaviorSubject<any>(null);
  employees = new BehaviorSubject<any>(null);
  branches = new BehaviorSubject<any>(null);
  editData = new BehaviorSubject<any>(null);
  customerId: number = null;

  constructor(private _base: BaseService) {
  }

  get(): Observable<any> {
    return this._base.get(
      `${this.customerEndPoint}/page?sortableColumn=id&size=25`
    );
  }

  invoiceTypes() {
    return this._base.get(`api/v1/issuing-type/page`);
  }
  PosInvoiceTypes() {
    return this._base.get(`api/v1/pos-invoice-type`);
  }
  getSupplier(customerId = ''): Observable<any> {
    let subApi = '';
    console.log(customerId, 'customerId');
    if (customerId) {
      subApi = `?customerId=${customerId}`;
    }

    return this._base.get(
      `${this.supplierEmployeeEndPoint}${subApi}`
    );

  }

  getAttachesBranch(id) {
    return this._base.get(`${this.attachesBranch}?branchId=${id}`);
  }

  // getShifts(): Observable<any> {
  //   return this._base.get(`${this.shiftsEndPoint}`);
  // }

  getInvoiceIssuingType() {
    return this._base.get(`${this.invoiceIssuingType}`);
  }


  // getEmployeeTypes(): Observable<any> {
  //   return this._base.get(`${this.employeeTypeEndPoint}`);
  // }

  getUsersById(id: number) {
    return this._base.get(`${this.usersEndPoint}/${id}`);
  }


  getCustomers() {
    return this._base.get(`${this.customerEndPoint}`);
  }

  getCountries() {
    return this._base.get(`${this.countriesEndPoint}`);
  }

  // getGovernorates(): Observable<any> {
  //   return this._base.get(`${this.governoratesEndPoint}`);
  // }
  //
  // getCities(): Observable<any> {
  //   return this._base.get(`${this.citiesEndPoint}`);
  // }

  getCustomerDataById(id) {
    return this._base.get(`${this.customerEndPoint}/${id}`);
  }

  getEmployeeById(id) {
    return this._base.get(`${this.branchEmployeeEndPoint}/${id}`);
  }

  // getCustomerBranches() {
  //   return this._base.get(`${this.customerBranchEndPoint}`);
  // }

  getCustomerBranchById(id) {
    return this._base.get(`${this.customerBranchEndPoint}/${id}`);
  }

  // getServiceCategories(): Observable<any> {
  //   return this._base.get(`${this.serviceCategoryEndPoint}`);
  // }

  getAccountManagers() {
    return this._base.get(`${this.accountManagerEndPoint}`);
  }

  getBranchesByCustomerId(id) {
    return this._base.get(
      `${this.customerBranchEndPoint}/findByCustomerId?customerId=${id}`
    );
  }

  addCustomer(requestBody) {
    return this._base.post(requestBody, this.customerEndPoint);
  }

  addCustomerBranch(requestBody): Observable<any> {
    return this._base.post(requestBody, this.customerBranchEndPoint);
  }


  getBankList() {
    return this._base.get(this.bankList);
  }

  updateCustomerBranch(requestBody) {
    return this._base.put(requestBody, this.customerBranchEndPoint);
  }

  addEmployee(requestBody) {
    return this._base.post(requestBody, this.branchEmployeeEndPoint);
  }

  updateEmployee(requestBody) {
    return this._base.put(requestBody, this.branchEmployeeEndPoint);
  }

  saveCustomerData(data) {
    return this._base.put(data, this.customerEndPoint);
  }

  getEmployeesByCustomerId(id) {
    return this._base.get(
      `${this.branchEmployeeEndPoint}/findByCustomerId?customerId=${id}`
    );
  }

  add(requestBody) {
    return this._base.post(requestBody, this.customerEndPoint);
  }

  update(requestBody): Observable<any> {
    return this._base.put(requestBody, this.customerEndPoint);
  }

  changeCustomerStatus(obj) {
    return this._base.put({}, `${this.customerEndPoint}/activation?customerId=${obj.id}&statusCode=${obj.statusCode}&deactivationReason=${encodeURIComponent(obj.reason || '')}`, {
      responseType: 'text',
    });
  }
  changeSuspend(obj) {
    return this._base.put({}, `${this.customerEndPoint}/suspend?customerId=${obj.id}&statusCode=${obj.statusCode}`, {
      responseType: 'text',
    });
  }

  delete(id: number): Observable<any> {
    return this._base.deleteById(`api/v1/customer/${id}?confirmPhrase=CONFIRM_DELETE`);
  }
  deleteBranchShift(id: number) {
    return this._base.deleteById(`api/v1/branch-shift/deleteById?id=${id}`);
  }

  deleteBranch(id: number) {
    return this._base.deleteById(`${this.customerBranchEndPoint}?id=${id}`);
  }

  deleteEmployee(id: number) {
    return this._base.deleteById(`${this.branchEmployeeEndPoint}?id=${id}`);
  }

  getDeliveryMethods() {
    return this._base.get(`${this.deliveryMethodList}`);
  }

  getServiceShopping() {
    return this._base.get(`${this.serviceShopping}`);
  }

  getServiceCategory(ids) {
    return this._base.get(`${this.serviceCategory}?ids=${ids}`);
  }

  // uploadItemAttachments(attachments: ItemAttach[]): Observable<any> {
  //   return this._base.post(attachments, 'api/v1/branch-attach/all');
  // }
  //
  // deleteItemAttach(itemAttachId: number): Observable<Item> {
  //   return this._base.deleteById(`api/v1/branch-attach?id=${itemAttachId}`);
  // }

  // setCustomers(customers: any) {
  //   this.customers.next(customers);
  // }

  setBranches(branches) {
    this.branches.next(branches);
  }

  setEmployees(employees) {
    this.employees.next(employees);
  }


  getListData(endPointUrl: string) {
    return this._base
      .get(endPointUrl)
      .pipe(
        catchError(
          this.handleError<Item>(
            `Get ${endPointUrl.split('/').pop()} Failded .. `
          )
        )
      );
  }

  /**
   *error handeler
   * @param operation
   * @param result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    console.log(operation)
    return (error): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  filter(obj?) {
    return this._base.post(obj, `api/v1/customer/filter`);
  }

  getBillingAccounts(searchCriteria) {
    return this._base.post({searchCriteria}, `${this.customerEndPoint}/billing-accounts`);
  }


  branchBasicInfo(branchId) {
    return this._base.get(`${this.branchBasicInfoEndPoint}/${branchId}`);
  }

  createBranchBasicInfo(basicObj) {
    return this._base.post(basicObj, `${this.branchBasicInfoEndPoint}`);
  }

  updateBranchBasicInfo(basicObj) {
    return this._base.put(basicObj, `${this.branchBasicInfoEndPoint}`);
  }


  branchDetails(branchId) {
    return this._base.get(`${this.branchDetailsEndPoint}/${branchId}`);
  }

  updateBranchDetails(detailsObj) {
    return this._base.put(detailsObj, `${this.branchDetailsEndPoint}`);
  }

  // branchGeneralSetup(branchId): Observable<any> {
  //   return this._base.get(`${this.branchGeneralEndPoint}/${branchId}`);
  // }

  branchConfigurationSetup(branchId) {
    return this._base.get(`${this.configurationEndPoint}/${branchId}`);
  }
  updateBranchConfigurationSetup(configurationSetupObj) {
    return this._base.put(configurationSetupObj, `${this.configurationEndPoint}`);
  }

  createBranchConfigurationSetup(configurationSetupObj) {
    return this._base.post(configurationSetupObj, `${this.configurationEndPoint}`);
  }

  // updateBranchGeneralSetup(generalSetupObj): Observable<any> {
  //   return this._base.put(generalSetupObj, `${this.branchGeneralEndPoint}`);
  // }

  branchBusiness(branchId) {
    return this._base.get(`${this.branchBusinessEndPoint}/${branchId}`);
  }

  updateBranchBusiness(branchBusinessObj) {
    return this._base.put(branchBusinessObj, `${this.branchBusinessEndPoint}`);
  }

  branchAddress(branchId) {
    return this._base.get(`${this.branchAddressEndPoint}/${branchId}`);
  }

  updateBranchAddress(branchAddressObj) {
    return this._base.put(branchAddressObj, `${this.branchAddressEndPoint}`);
  }

  branchDeliveryMethods(branchId) {
    return this._base.get(`${this.branchDeliveryMethodsEndPoint}/${branchId}`);
  }
  branchTimeSheet(branchId) {
    return this._base.get(`${this.branchTimeSheetEndPoint}/${branchId}`);
  }

  updateBranchTimeSheet(branchTimeSheetObj) {
    return this._base.put(branchTimeSheetObj, `${this.branchTimeSheetEndPoint}`);
  }

  updateBranchDeliveryMethods(branchDeliveryMethodsObj) {
    return this._base.put(branchDeliveryMethodsObj, `${this.branchDeliveryMethodsEndPoint}`);
  }

  branchDayofWork(branchId) {
    return this._base.get(`${this.branchDayofWorkEndPoint}/${branchId}`);
  }

  updateBranchDayofWork(branchDayofWorkObj) {
    return this._base.put(branchDayofWorkObj, `${this.branchDayofWorkEndPoint}`);
  }

  getSalaryElementEarning() {
    return this._base.get(`${this.salaryElementEarning}`);
  }

  createBranchDetails(details) {
    return this._base.post(details, this.branchDetailsEndPoint);
  }
}
